(() => {
  if (window.LorahQuantityOffers) return;
  const root = window.Shopify?.routes?.root || '/';
  let queue = Promise.resolve();
  function enqueue(task) { const result = queue.then(task, task); queue = result.catch(() => {}); return result; }
  function campaigns() {
    for (const script of document.scripts) {
      const text = script.textContent || '';
      const match = /(?:var\s+)?_RSI_COD_FORM_QUANTIY_OFFERS\s*=\s*(\[)/.exec(text);
      if (!match) continue;
      const start = match.index + match[0].length - 1;
      let depth = 0, quoted = false, escaped = false;
      for (let i = start; i < text.length; i++) {
        const c = text[i];
        if (quoted) { if (escaped) escaped = false; else if (c === '\\') escaped = true; else if (c === '"') quoted = false; continue; }
        if (c === '"') quoted = true;
        else if (c === '[') depth++;
        else if (c === ']' && --depth === 0) {
          try { const value = JSON.parse(text.slice(start, i + 1)); if (Array.isArray(value)) return value; } catch (_) {}
          break;
        }
      }
    }
    return null;
  }
  const unique = values => [...new Set(values.map(String))];
  const same = (a,b) => a.map(x=>x.toUpperCase()).sort().join(',') === b.map(x=>x.toUpperCase()).sort().join(',');
  function select(cart, offers) {
    if (!Array.isArray(cart.discount_codes)) return null;
    const current = cart.discount_codes.map(x => x.code);
    const wanted = current.filter(x => !/^RSI_QUANTITY_/i.test(x));
    const quantities = new Map();
    for (const item of cart.items || []) quantities.set(String(item.product_id),(quantities.get(String(item.product_id)) || 0) + item.quantity);
    const claimed = new Set();
    const capped = [];
    const unsupported = [];
    for (const campaign of offers) {
      if (!campaign.isActive || !Array.isArray(campaign.pIds) || !Array.isArray(campaign.offers)) continue;
      const present = unique(campaign.pIds).filter(id=>quantities.has(id));
      if (!present.length || present.some(id=>claimed.has(id))) continue;
      present.forEach(id=>claimed.add(id));
      // A shared Shopify code cannot assign different tiers to different products.
      const counts = unique(present.map(id=>quantities.get(id)));
      if(counts.length !== 1) continue;
      const count=Number(counts[0]);
      const tier = campaign.offers.filter(x => Number.isInteger(Number(x.qty)) && Number(x.qty)>0 && Number(x.qty)<=count).sort((a,b)=>Number(b.qty)-Number(a.qty))[0];
      const code = tier?.ds?.d?.code;
      if (!tier || tier.ds?.t === 'none' || typeof code !== 'string' || !/^RSI_QUANTITY_[A-Za-z0-9_-]+$/.test(code)) continue;
      if(count > Number(tier.qty)) {
        if(tier.ds.t !== 'fixed' || present.length !== 1 || !Number.isInteger(tier.ds.v) || tier.ds.v <= 0) {
          unsupported.push({productIds:present,quantity:count,reason:'La oferta necesita un descuento fijo total para cobrar las unidades extra a precio normal.'});
          continue;
        }
        capped.push({code,amount:tier.ds.v,productId:present[0]});
      }
      wanted.push(code);
    }
    return { current:unique(current), wanted:unique(wanted), capped, unsupported };
  }
  async function read() {
    const response = await fetch(root + 'cart.js', {cache:'no-store',headers:{Accept:'application/json'}});
    if(!response.ok) throw new Error('No se pudo comprobar el carrito.');
    return response.json();
  }
  async function sync(cart, sections, sectionsURL) {
    if(document.querySelector('#rsi_form_wrapper[open]')) return cart;
    const offers=campaigns();
    if(!offers) return cart;
    const plan=select(cart,offers);
    if(!plan) return cart;
    if(plan.unsupported.length) console.warn('Lorah: oferta con unidades extra no compatible.',plan.unsupported);
    function invalidCaps(value) {
      return plan.capped.filter(cap=>{
        const allocations=(value.items || []).flatMap(item=>(item.line_level_discount_allocations || []).filter(a=>a.discount_application?.title?.toUpperCase()===cap.code.toUpperCase()).map(a=>({amount:a.amount,productId:String(item.product_id)})));
        return allocations.some(a=>a.productId!==cap.productId) || allocations.reduce((sum,a)=>sum+a.amount,0)>cap.amount;
      }).map(cap=>cap.code);
    }
    if(same(plan.current,plan.wanted) && !invalidCaps(cart).length) return cart;
    const body={discount:plan.wanted.join(',')};
    if(sections) {body.sections=sections;body.sections_url=sectionsURL || location.pathname;}
    const response=await fetch(root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)});
    if(!response.ok) throw new Error('Shopify no pudo actualizar la oferta.');
    const result=await response.json();
    if(!Array.isArray(result.items)) throw new Error('Respuesta de descuento no válida.');
    const invalid=invalidCaps(result);
    if(invalid.length) {
      console.warn('Lorah: el código no limita el ahorro al paquete; se retira.',invalid);
      body.discount=plan.wanted.filter(code=>!invalid.includes(code)).join(',');
      const correction=await fetch(root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)});
      if(!correction.ok) throw new Error('No se pudo retirar la oferta incompatible.');
      return correction.json();
    }
    return result;
  }
  function warn(error) {console.error('Lorah: oferta no sincronizada; se conservan los importes reales de Shopify.',error);}
  async function mutate(url,options) {
    return enqueue(async()=>{
      let body;
      try {body=JSON.parse(options.body);} catch(_) {return fetch(url,options);}
      // Discounts can change line keys. Rebase only an unambiguous variant.
      if(typeof body.id==='string' && body.id.includes(':')) {
        const before=await read();
        if(!before.items.some(item=>item.key===body.id)) {
          const variant=body.id.split(':')[0];
          const matches=before.items.filter(item=>String(item.variant_id)===variant);
          if(matches.length===1) body.id=matches[0].key;
        }
      }
      const response=await fetch(url,{...options,body:JSON.stringify(body)});
      if(!response.ok) return response;
      const original=await response.clone().json();
      if(original.errors || original.status) return response;
      try {
        const isCart=Number.isInteger(original.item_count);
        const cart=isCart?original:await read();
        const updated=await sync(cart,body.sections,body.sections_url);
        if(updated===cart && isCart) return response;
        let data=updated;
        if(!isCart) {
          // Preserve add.js response shape and return current keys for added lines.
          data={...original,sections:updated.sections || original.sections,lorah_cart:{...updated,sections:updated.sections || original.sections}};
          if(Array.isArray(original.items)) data.items=original.items.map(item=>{
            const matches=updated.items.filter(x=>String(x.variant_id)===String(item.variant_id) && JSON.stringify(x.properties||{})===JSON.stringify(item.properties||{}));
            return matches.length===1?{...item,key:matches[0].key}:item;
          });
        }
        const headers=new Headers(response.headers);headers.delete('content-length');headers.delete('content-encoding');headers.set('content-type','application/json');
        return new Response(JSON.stringify(data),{status:response.status,headers});
      } catch(error) {warn(error);return response;}
    });
  }
  window.LorahQuantityOffers={
    mutate,
    reconcile:()=>enqueue(async()=>{try{return await sync(await read());}catch(error){warn(error);return null;}}),
    select
  };
})();

